// extracted by mini-css-extract-plugin
export var background = "_5r-0";
export var container = "_5r-1";
export var contentItem = "_5r-7";
export var extendedWarranty = "_5r-5";
export var link = "_5r-d";
export var modal = "_5r-b";
export var modalCloseButton = "_5r-9";
export var modalContent = "_5r-3";
export var modalContentMain = "_5r-6";
export var modalImageLogo = "_5r-8";
export var modalLogo = "_5r-a";
export var modalSideImage = "_5r-4";
export var preview = "_5r-c";
export var redoModal = "_5r-2";